<template>
  <div style="min-height: calc(100vh - 158px);" class="card">
    <div style="background: #DBE7F2" class="card p-2">
      <TitleButton
          :showBtn="false"
          title="Payment Requisition Summary"
      />
      
      <div class="d-flex justify-content-between align-items-center px-2 mt-2">
        <div class="summary-info d-flex gap-4">
          <div><span class="fw-bold">Total Vouchers:</span> {{ summaryData.total_vouchers }}</div>
          <div><span class="fw-bold">Total Cheques:</span> {{ summaryData.total_cheques }}</div>
          <div><span class="fw-bold">Total Amount:</span> {{ commaFormat(summaryData.grand_total) }}</div>
        </div>
        <div>
          <button class="btn btn-primary btn-sm" @click="printReport">
            <i class="fa fa-print"></i> Print
          </button>
        </div>
      </div>
    </div>

    <div class="card px-2 mt-2 report-table-container">
      <div v-for="(group, index) in summaryData.groups" :key="index" class="mb-2 group-section">
        <div class="group-header bg-blue-light border p-2 fw-bold text-center mb-0" style="background:rgb(209 218 227)">
          Payment Method: {{ group.account_head_name }}
        </div>
        <div class="table-responsive">
          <table class="table table-bordered mb-0 custom-report-table">
            <thead>
              <tr>
                <th class="text-center" style="width: 50px;">SL</th>
                <th>Payee</th>
                <th>Voucher Description</th>
                <th>Voucher(s) No</th>
                <th class="text-center">Cheque No</th>
                <th class="text-center">Cheque Date</th>
                <th class="text-right">Amount</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, i) in group.items" :key="i">
                <td class="text-center">{{ i + 1 }}</td>
                <td>{{ item.payee }}</td>
                <td style="max-width: 250px;">{{ item.voucher_descriptions }}</td>
                <td>{{ item.voucher_nos }}</td>
                <td class="text-center">{{ item.cheque_no }}</td>
                <td class="text-center">{{ item.cheque_date }}</td>
                <td class="text-right">{{ commaFormat(item.amount) }}</td>
              </tr>
            </tbody>
            <tfoot>
              <tr class="fw-bold">
                <td colspan="6" class="text-uppercase text-end">Total</td>
                <td class="text-right">{{ commaFormat(group.sub_total) }}</td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>

      <div class="grand-total-section mt-3 mb-4 border-top border-bottom py-2 px-2" v-if="summaryData.groups.length > 0">
        <div class="d-flex justify-content-between fw-bold">
          <div class="text-uppercase">Grand Total</div>
          <div class="fs-5">{{ commaFormat(summaryData.grand_total) }}</div>
        </div>
      </div>
      
      <div v-if="summaryData.groups.length === 0 && !loading" class="text-center py-5">
        <p class="text-muted">No data found for summary.</p>
      </div>
    </div>

    <Loader v-if="loading" />
  </div>
</template>

<script setup>
import { ref, onMounted, inject, computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import handleAccounting from '@/services/modules/accounting';
import handleCompany from "@/services/modules/company";
import figureFormatter from '@/services/utils/figureFormatter';
import pdfPrinter from '@/services/utils/pdf/PaymentRequisitionSummaryPdf';
import Loader from '@/components/atom/LoaderComponent';
import TitleButton from '@/components/atom/TitleButton';

const route = useRoute();
const router = useRouter();
const showError = inject('showError');
const { commaFormat } = figureFormatter();
const { fetchChequeRegisterSummary } = handleAccounting();
const { fetchCompanyInfo } = handleCompany();
const { exportToPDF } = pdfPrinter();

const loading = ref(false);
const summaryData = ref({
  groups: [],
  grand_total: 0,
  total_cheques: 0,
  total_vouchers: 0
});
const companyInfo = ref({});

const companyId = computed(() => route.params.companyId);

const getSummary = async () => {
  loading.value = true;
  try {
    const query = `?company_id=${route.params.companyId}`;
    const res = await fetchChequeRegisterSummary(query);
    if (! res.status) {
      return
    }
    summaryData.value = res.data;
  } catch (err) {
    console.error(err);
  } finally {
    loading.value = false;
  }
};

const getCompanyInfo = async () => {
  await fetchCompanyInfo(companyId.value).then((res) => {
    companyInfo.value = res.data
  })
}

const printReport = () => {
  exportToPDF(companyInfo.value, summaryData.value);
};

onMounted(() => {
  getSummary();
  getCompanyInfo();
});
</script>

<style scoped>
.custom-report-table th {
  padding: 8px 4px;
  font-size: 13px;
  background-color: #f8f9fa;
}

.custom-report-table td {
  padding: 4px;
  font-size: 12px;
}

.bg-blue-light {
    background-color: #DBE7F2;
}

.fw-bold {
  font-weight: 700 !important;
}
</style>
